import React, { ReactElement, useState } from 'react';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import {
  getSearchEventData,
  getSearchEventName,
  handleSetSearchTerm,
  handleToggleSearchForm,
  SearchContainer,
  SearchPopupContainer,
} from '../../../catalog';
import { IconArrowComponent, IconMagnifierComponent } from '../../icons';
import { useTheme } from '../../../hooks';
import { getAdditionalColors } from '../../company';
import { pushDataLayer, urlService } from '../../../services';
import { mainPath } from '../../../constants';
import { MetaPaginationModel, QueryParams } from '../../../models';
import { CoursesSearchModel } from './coursesSearch.model';

export const CoursesSearchContainer = ({
  isSticky,
}: CoursesSearchModel): ReactElement => {
  const theme = useTheme();
  const router = useRouter();
  const dispatch = useDispatch();
  const { filtersAccentColor } = getAdditionalColors();

  const [searchTerm, setSearchTerm] = useState<string>('');

  const handleClickSuggest = (
    term: string,
    title: string,
    meta?: MetaPaginationModel,
    isShowAll?: boolean
  ): void => {
    const trimTitle = title.trim();

    if (!!trimTitle) {
      pushDataLayer(
        getSearchEventData(
          getSearchEventName(isSticky, isShowAll),
          term,
          trimTitle,
          meta?.total
        )
      );
    }

    dispatch(handleSetSearchTerm(trimTitle));
    setSearchTerm(trimTitle);

    router.push(
      urlService.getFullUrlToPage(
        mainPath.courses,
        { ...router, query: { [QueryParams.title]: trimTitle } },
        [QueryParams.title],
        undefined,
        true
      ),
      undefined,
      { scroll: false }
    );
  };

  const handleClose = () => {
    dispatch(handleToggleSearchForm(false, null));
  };

  return (
    <SearchPopupContainer
      children={
        <SearchContainer
          initialTerm={searchTerm}
          magnifierIcon={
            <IconMagnifierComponent
              fillColor={theme.COLOR.TEXT_LIGHT_COLOR}
              strokeColor={theme.COLOR.TEXT_LIGHT_COLOR}
            />
          }
          suggestItemArrowIcon={
            <IconArrowComponent strokeColor={theme.COLOR.TEXT_LIGHT_COLOR} />
          }
          handleClickSuggest={handleClickSuggest}
          handleClose={handleClose}
          accentColor={filtersAccentColor}
        />
      }
      handleClose={handleClose}
      isMobile={theme.IS_MOBILE}
    />
  );
};
